import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './App.css';
import loginImage from './LoginImage2.png';

const IconUser = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
    strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);

const IconLock = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
    strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="3" y="11" width="18" height="11" rx="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);

const IconBuilding = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
    strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="4" y="3" width="16" height="18" rx="2" />
    <path d="M9 8h.01M15 8h.01M9 12h.01M15 12h.01M10 21v-4h4v4" />
  </svg>
);

const IconEye = ({ off }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
    strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    {off ? (
      <>
        <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
        <path d="M9.88 9.88a3 3 0 1 0 4.24 4.24" />
        <line x1="1" y1="1" x2="23" y2="23" />
      </>
    ) : (
      <>
        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
        <circle cx="12" cy="12" r="3" />
      </>
    )}
  </svg>
);

const IconAlert = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
    strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="8" x2="12" y2="12" />
    <line x1="12" y1="16" x2="12.01" y2="16" />
  </svg>
);

const IconCheck = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"
    strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

const HIGHLIGHTS = [
  'İzin talep ve onay süreçleri tek akışta',
  'Yıllık hakediş ve devir takibi',
  'Resmî tatil ve çalışma takvimi yönetimi',
];

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [company, setCompany] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const response = await fetch('https://api.idekod.com.tr/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password, company })
      });
      const data = await response.json();
      if (data.success) {
        localStorage.setItem('username', username);
        localStorage.setItem('role', data.role);
        localStorage.setItem('company', company);
        navigate('/home');
      } else {
        setError('Hatalı kullanıcı adı, şifre veya kurum kısa kodu.');
        setLoading(false);
      }
    } catch (err) {
      console.error('There was an error logging in!', err);
      setError('Sunucuya ulaşılamadı. Lütfen bağlantınızı kontrol edip tekrar deneyin.');
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <aside className="login-page__visual">
        <div className="login-brand">
          <div className="login-brand__logo">
            <img src={loginImage} alt="İDEKOD" />
          </div>
          <h1 className="login-brand__title">Personel Takip Sistemi</h1>
          <p className="login-brand__desc">
            Personel kayıtlarını, izin süreçlerini ve hakediş takibini tek panelden yönetin.
          </p>
          <ul className="login-brand__list">
            {HIGHLIGHTS.map(item => (
              <li key={item}>
                <span className="login-brand__tick"><IconCheck /></span>
                {item}
              </li>
            ))}
          </ul>
        </div>
        <p className="login-brand__foot">
          &copy; {new Date().getFullYear()} İDEKOD &middot; Tüm hakları saklıdır.
        </p>
      </aside>

      <main className="login-page__form-wrap">
        <form onSubmit={handleSubmit} className="login-page__form">
          <div className="login-page__mobile-logo">
            <img src={loginImage} alt="İDEKOD" />
          </div>

          <header className="login-page__header">
            <h2 className="login-page__title">Giriş Yap</h2>
            <p className="login-page__subtitle">
              Devam etmek için hesap bilgilerinizi girin.
            </p>
          </header>

          {error && (
            <div className="login-alert" role="alert">
              <IconAlert />
              <span>{error}</span>
            </div>
          )}

          <div className="form-field">
            <label className="form-label" htmlFor="login-username">Kullanıcı Adı</label>
            <div className="login-field">
              <span className="login-field__icon"><IconUser /></span>
              <input
                id="login-username"
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                autoFocus
                autoComplete="username"
                placeholder="kullanici.adi"
                className="form-control login-field__input"
              />
            </div>
          </div>

          <div className="form-field">
            <label className="form-label" htmlFor="login-password">Şifre</label>
            <div className="login-field login-field--action">
              <span className="login-field__icon"><IconLock /></span>
              <input
                id="login-password"
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="current-password"
                placeholder="••••••••"
                className="form-control login-field__input"
              />
              <button
                type="button"
                className="login-field__toggle"
                onClick={() => setShowPassword(v => !v)}
                aria-label={showPassword ? 'Şifreyi gizle' : 'Şifreyi göster'}
                title={showPassword ? 'Şifreyi gizle' : 'Şifreyi göster'}
              >
                <IconEye off={showPassword} />
              </button>
            </div>
          </div>

          <div className="form-field">
            <label className="form-label" htmlFor="login-company">Kurum Kısa Kodu</label>
            <div className="login-field">
              <span className="login-field__icon"><IconBuilding /></span>
              <input
                id="login-company"
                type="text"
                value={company}
                onChange={(e) => setCompany(e.target.value)}
                required
                autoComplete="organization"
                placeholder="Örn. IDEKOD"
                className="form-control login-field__input"
              />
            </div>
            <span className="form-helper">Kurumunuza tanımlı kısa kodu girin.</span>
          </div>

          <button
            type="submit"
            className="btn btn--primary btn--block btn--lg login-page__submit"
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="login-spinner" aria-hidden="true" />
                Giriş yapılıyor…
              </>
            ) : (
              'Giriş Yap'
            )}
          </button>

          <p className="login-page__help">
            Erişim sorunu mu yaşıyorsunuz? Kurum yöneticinizle iletişime geçin.
          </p>
        </form>
      </main>
    </div>
  );
};

export default Login;
